(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate"] && !Shopify.designMode) return;
  try {
    
  function initAffiliateHeroVideo() {
    const heroSections = document.querySelectorAll('.section--affiliate-hero');

    heroSections.forEach((heroSection) => {
      const video = heroSection.querySelector('.affiliate-hero__video video');
      const unmuteButton = heroSection.querySelector('.affiliate-hero__video-unmute');

      if (!video || !unmuteButton || unmuteButton.dataset.initialized === 'true') return;

      unmuteButton.dataset.initialized = 'true';

      unmuteButton.addEventListener('click', () => {
        video.muted = false;
        video.controls = true;
        unmuteButton.style.display = 'none';

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAffiliateHeroVideo);
  } else {
    initAffiliateHeroVideo();
  }

  document.addEventListener('shopify:section:load', initAffiliateHeroVideo);

  } catch(e) { console.error(e); }
})();
})();
